// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const getHistoryApiAssetsAssetIdHistoryGetParamsPageDefault = 1;

export const getHistoryApiAssetsAssetIdHistoryGetParamsPageSizeDefault = 50;
export const getHistoryApiAssetsAssetIdHistoryGetParamsPageSizeMax = 200;

export const GetHistoryApiAssetsAssetIdHistoryGetParams = zod.object({
  "page": zod.int().min(1).default(getHistoryApiAssetsAssetIdHistoryGetParamsPageDefault),
  "page_size": zod.int().min(1).max(getHistoryApiAssetsAssetIdHistoryGetParamsPageSizeMax).default(getHistoryApiAssetsAssetIdHistoryGetParamsPageSizeDefault)
})

export type GetHistoryApiAssetsAssetIdHistoryGetParams = zod.input<typeof GetHistoryApiAssetsAssetIdHistoryGetParams>;
export type GetHistoryApiAssetsAssetIdHistoryGetParamsOutput = zod.output<typeof GetHistoryApiAssetsAssetIdHistoryGetParams>;
